// services
import db from '@/services/db'

export default {
  dataGrid_update({ commit }, log) {
    if (log.type === 'GridChange') commit('dataGrid_onGridLogArrived', log)
    if (log.type === 'RowChange') commit('dataGrid_onRowLogArrived', log)
    if (log.type === 'CellChange') commit('dataGrid_onCellLogArrived', log)
  },
  dataGrid_logGridChange({ state }, { gridId, value: gridToLog }) {
    let dataGrid = state.models_dashboardModel[gridId]

    if (!dataGrid) {
      state.models_dashboardModel[gridId] = {}
      dataGrid = state.models_dashboardModel[gridId]
    }

    const meta = state.dataGrid_options[gridId].meta
    let newVal = {}

    if (!meta)
      throw new Error(`No columns defined for "${gridId}" DataGrid component`)

    for (let rowKey in gridToLog) {
      newVal[rowKey] = {}
      const rowToLog = gridToLog[rowKey]

      for (let cellKey in rowToLog) {
        if (typeof rowToLog[cellKey] === 'undefined') continue

        newVal[rowKey][cellKey] = rowToLog[cellKey]
      }
    }

    const logVal = {
      type: 'GridChange',
      gridId,
    }

    if (newVal) logVal.newVal = JSON.stringify(newVal)

    db.dataGridLogs.log(logVal)
  },
  dataGrid_logRowChange(
    { state },
    { gridId, rowKey, id, value: rowToLog, group, notForAdmin, cb }
  ) {
    let dataGrid = state.models_dashboardModel[gridId]

    if (!dataGrid) {
      state.models_dashboardModel[gridId] = {}
      dataGrid = state.models_dashboardModel[gridId]
    }

    const meta = state.dataGrid_options[gridId].meta
    let newVal

    if (!meta)
      throw new Error(`No columns defined for "${gridId}" DataGrid component`)

    if (rowToLog) {
      newVal = { rowKey }

      for (let cellKey in rowToLog) {
        if (typeof rowToLog[cellKey] === 'undefined') continue

        newVal[cellKey] = rowToLog[cellKey]
      }
    }

    const oldVal =
      typeof dataGrid[rowKey] !== 'undefined' ? dataGrid[rowKey] : null
    const logVal = {
      type: 'RowChange',
      gridId,
      rowKey,
    }

    if (group) logVal.group = group
    else logVal.group = newVal && newVal.group ? newVal.group : false
    if (notForAdmin) logVal.notForAdmin = true

    if (id) logVal.id = id
    if (oldVal) logVal.oldVal = JSON.stringify(oldVal)
    if (newVal) logVal.newVal = JSON.stringify(newVal)

    state.dataGridLogsValue = logVal
    db.dataGridLogs.log(logVal)
      .then(function() {
        if (cb) cb()
      })
  },
  dataGrid_logCellChange({ state, dispatch }, payload) {
    const { gridId, rowKey, cellKey, value: cellValToLog } = payload
    const rowData = state.models_dashboardModel[gridId][rowKey]
    const oldVal = state.models_dashboardModel[gridId][rowKey][cellKey]
    const logVal = {
      type: 'CellChange',
      gridId,
      rowKey,
      cellKey,
    }

    if (cellValToLog) logVal.newVal = cellValToLog
    if (oldVal) logVal.oldVal = oldVal
    if(payload.isLookup) logVal.isLookup = true
    if (rowData.group) logVal.group = rowData.group

    if (cellKey === 'group') {
      const curRowVal = state.models_dashboardModel[gridId][rowKey]

      if (!logVal.newVal) {
        curRowVal.group = false

        dispatch('dataGrid_logRowChange', {
          gridId,
          rowKey,
          id: curRowVal._id,
          value: curRowVal,
        })
      } else {
        const curRowGroup = curRowVal.group
        curRowVal.group = logVal.newVal

        const cb = function() {
          dispatch('dataGrid_logRowChange', {
            gridId,
            rowKey,
            id: curRowVal._id,
            value: curRowVal,
            group: logVal.newVal,
          })
        }

        dispatch('dataGrid_logRowChange', {
          gridId,
          rowKey,
          id: curRowVal._id,
          value: null,
          group: curRowGroup,
          notForAdmin: true,
          cb,
        })
      }
    }

    state.dataGridLogsValue = logVal
    db.dataGridLogs.log(logVal)
  },
}
